import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'lum-picklist-virtual-calculator-form',
  templateUrl: './picklist-virtual-calculator-form.component.html',
  styleUrls: ['./picklist-virtual-calculator-form.component.scss'],
})
export class PicklistVirtualCalculatorFormComponent {
  quantity :number;
  constructor(
    private dialogRef :MatDialogRef<PicklistVirtualCalculatorFormComponent>,
  ) {}

  onValueChange(value :number) :void {
    this.quantity = value;
  }

  onSave() :void {
    this.dialogRef.close(Number(this.quantity));
  }
}
